import { endPoints } from 'api/';
import { DELETE_INTEGRATION } from 'actions/types';

export function deleteIntegration(id, payload) {
  /**
   * @param {Function} dispatch
   */
  return function (dispatch) {
    const action = {
      type: DELETE_INTEGRATION,
      /**
       * @param {Function} apiClient
       */
      request: async function (apiClient) {
        return await apiClient(endPoints.DELETE_INTEGRATION, payload, id);
      },
    };
    dispatch(action);
  };
}
